import { render, staticRenderFns } from "./FormLanguages.vue?vue&type=template&id=4b5158c0"
import script from "./FormLanguages.vue?vue&type=script&lang=js"
export * from "./FormLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports